<!-- @Version: 1.1.0 --> 
@if ((done$ | async) == true) {
   <div class="dialog-frame as-page">
      <mat-dialog-content class="mat-typography" align="center" data-testid="translate">
         <div class="dialogcol">
            <div class="top">
               <app-fileupload (dataUrlSaveChange)="setNewFiles($event)"
                  [translatePath]="translatePath"
                  [maxFilesize]="(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_MAXFILESIZE) | translateDesign"
                  [actMaxNumberOfFiles]="numberFiles && numberFiles > -1 ? numberFiles : (translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_MAXNUMBEROFFILES) | translateDesign"
                  [allowedExtensions]="filetype && filetype.length > 0 ? filetype : (translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_ALLOWEDEXTENSIONS) | translateDesign"
                  [maxNumberFiles]="initNumberFiles ? initNumberFiles : (translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_MAXNUMBEROFFILES) | translateDesign"
                  [readonly]="initNumberFiles ? fileData.length >= initNumberFiles : fileData.length >= +((translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_MAXNUMBEROFFILES) | translateDesign)">
               </app-fileupload>
            </div>
            @for (file of fileData; track file) {
               <div class="bottom">
                  <div class="file">
                     <a target="_blank" [attr.href]="(file.url | sanitizerTrustUrl)" [attr.download]="file.filename">
                        <mat-icon [color]="(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_SHOW_ICON_COLOR) | translateDesign">{{(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_SHOW_ICON) | translateDesign}}</mat-icon>
                     </a>
                     <div>{{file.filename}}</div>
                  </div>
                  <div class="end">
                     <mat-icon [color]="(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_REMOVE_ICON_COLOR) | translateDesign" (click)="removeFile(file.lfnr)">{{(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_REMOVE_ICON) | translateDesign}}</mat-icon>
                     <div class="filesize">{{(file.size / 1000) | number:'1.2-2':'de-DE'}} {{(translatePath + TRANSLATE_PATH_SHARED.FILEUPLOAD_SIZE_SUFFIX) | translateDesign}}</div>
                  </div>
               </div>
            }
         </div>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
         <div class="buttons">
            <button [color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translateDesign" mat-stroked-button mat-dialog-close data-testid="exit">{{(translatePath + TRANSLATE_PATH_SHARED.DIALOG_FILEUPLOAD_BUTTON_CANCEL) | translateDesign}}</button>
            @if (!data.metaData.required) {
               <button [color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translateDesign" mat-stroked-button [disabled]="fileData && fileData.length == 0" (click)="onDeleteClick()" data-testid="exit">{{(translatePath + TRANSLATE_PATH_SHARED.DIALOG_FILEUPLOAD_BUTTON_DELETE) | translateDesign}}</button>
            }
            <button [color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translateDesign" mat-raised-button mat-dialog-close data-testid="exit" (click)="onSaveButton()" [disabled]="fileData.length == 0 && data.metaData.required">{{(translatePath + TRANSLATE_PATH_SHARED.DIALOG_FILEUPLOAD_BUTTON_SAVE) | translateDesign}}</button>
         </div>
      </mat-dialog-actions>
   </div>
}
@if (sSpinner.enabled) {
   <app-spinner></app-spinner>
}